import { Stack } from '@mui/system';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import DataRoomObjectEditor from '~components/dashboard/DataRoomObjectEditor/DataRoomObjectEditor';
import DashboardPageLayout from '~components/layout/DashboardPageLayout';
import PageLoader from '~components/miscs/PageLoader';
import {
  selectProjectConfigError,
  selectProjectConfigIsLoading,
} from '~features/project-config/project-config.selectors';
import { getProjectConfig } from '~features/project-config/project-config.slice';
import { selectProjectDataRoomObject } from '~features/project-data-room/project-data-room.selectors';
import {
  getProjectDataRoomObject,
  resetDataRoomObject,
  setNewDataObjectId,
} from '~features/project-data-room/project-data-room.slice';
import useAppDispatch from '~hooks/useAppDispatch';
import useAppSelector from '~hooks/useAppSelector';
import NotFoundView from '~views/NotFoundView';

const ProjectDataRoomObjectView = () => {
  const dispatch = useAppDispatch();

  const dataRoomObject = useAppSelector(selectProjectDataRoomObject);
  const isLoading = useAppSelector(selectProjectConfigIsLoading);
  const isError = useAppSelector(selectProjectConfigError);

  const location = useLocation();
  const objectId = location.pathname.split('/')[location.pathname.split('/').length - 1];
  const projectId = location.pathname.split('/')[3];

  console.log(dataRoomObject);

  useEffect(() => {
    dispatch(setNewDataObjectId(''));
    dispatch(getProjectConfig({ id: projectId, force: false }));
    dispatch(getProjectDataRoomObject(objectId));

    return () => {
      dispatch(resetDataRoomObject());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading || !dataRoomObject) {
    return <PageLoader />;
  }

  if (isError) {
    return <NotFoundView />;
  }

  return (
    <DashboardPageLayout>
      <Stack gap={2}>
        <DataRoomObjectEditor object={dataRoomObject} />
      </Stack>
    </DashboardPageLayout>
  );
};

export default ProjectDataRoomObjectView;
